import { arrayHas } from "../utils/arrayHas.js";
import { hooks as hooks$1 } from "./modules/relationship/hooks.js";
import { hooks as hooks$2 } from "./modules/table/hooks.js";
import { hooks as hooks$3 } from "./modules/table-column/hooks.js";
import { Subject } from "rxjs";
//#region src/engine/store-hooks.ts
var hooks = [
	...hooks$2,
	...hooks$3,
	...hooks$1
];
function createHooks(store) {
	const getState = () => store.state;
	const tasks = hooks.map(([pattern, hook]) => {
		const action$ = new Subject();
		return {
			pattern: arrayHas(pattern.map(String)),
			action$,
			subscription: hook(action$, getState, store.context)
		};
	});
	const unsubscribe = store.subscribe((actions) => {
		for (const action of actions) for (const task of tasks) if (task.pattern(action.type)) task.action$.next(action);
	});
	const destroy = () => {
		tasks.forEach(({ action$, subscription }) => {
			subscription.unsubscribe();
			action$.complete();
		});
		tasks.splice(0, tasks.length);
		unsubscribe();
	};
	return { destroy };
}
//#endregion
export { createHooks };
